// src/hooks/usePageContent.js
import { useState } from 'react';
import { getAllPage } from '../services/pageContentService';

const usePageAll = () => {
    const [status, setStatus] = useState('idle'); // idle | loading | done | error
    const [error, setError] = useState('');
    const [data, setData] = useState([]);

    const fetchPage = async () => {
        setStatus('loading');
        setError('');

        try {
            const response = await getAllPage();

            if (response?.status !== 'Error') {
                setData(response.data ?? response); // depending on API shape
                setStatus('done');
            } else {
                setStatus('error');
                setError(response?.message || 'Something went wrong');
            }
        } catch (err) {
            setStatus('error');
            setError(err?.message || 'Something went wrong');
        }
    };

    const resetStatus = () => {
        setStatus('idle');
        setError('');
    };

    return {
        fetchPage,
        data,
        status,
        error,
        resetStatus
    };
};

export default usePageAll;
